import React, { useEffect } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { get as getCookie } from 'es-cookie'
import { track } from '@amplitude/analytics-browser'

const PrivateRoute = ({ component: Component, ...rest }) => {
  useEffect(() => {
    track('Page View', {
      name: window.location.pathname,
    })
  })

  return (
    <Route
      {...rest}
      render={props => {
        if (getCookie('token') == null) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location },
              }}
            />
          )
        }
        if (
          window.CONSTANTS?.IS_TRIAL_EXPIRED &&
          props.location.pathname !== '/trial-expired'
        ) {
          return <Redirect to="/trial-expired" />
        }
        return <Component {...props} />
      }}
    />
  )
}

export default PrivateRoute
